import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import '@/DIContainer'
import { ClientProfile } from '@core/pages/client-management/model/ClientProfile'
import { ClientProductMeta } from '@core/pages/client-management/model/ClientProductMeta'
import { ProductFullMetaList } from '@master/model/common/ProductFullMetaList'
import { container } from 'inversify-props'
import API from '@core/services/API'
import { ClientResponseDto, ClientService, ClientUpdateRequestDTO } from '../api'

const $api = container.get<API>('$api')

@Module({
  namespaced: true
})
export default class ClientInfoStore extends VuexModule {
  clientProfile: ClientProfile = new ClientProfile()
  highRiskClient = false
  clientProduct: ClientProductMeta = new ClientProductMeta()
  productList: ProductFullMetaList = new ProductFullMetaList([])
  readOnly = false

  // Version 2 of CLient DTO
  clientDto: ClientResponseDto = undefined

  @Mutation
  setClientDtoV2 (clientDto: ClientResponseDto) {
    this.clientDto = clientDto
  }

  @Action
  async retrieveClientDTOV2 (clientOid: string) {
    try {
      const dto = await ClientService.retrieveClientWithOid(clientOid)
      this.context.commit('setClientDtoV2', dto)
    } catch (error) {
      console.log(error)
    }
  }

  @Action
  async updateClientDTOV2 (clientUpdateRequestDTO: ClientUpdateRequestDTO) {
    try {
      const dto = await ClientService.updateClientData(clientUpdateRequestDTO)
      this.context.commit('setClientDtoV2', dto)
    } catch (error) {
      console.log(error)
    }
  }

  @Mutation
  setClientProfile (profile: ClientProfile) {
    this.clientProfile.extractAndAssignData(profile)
    if (this.clientProfile?.hrcRoles) {
      this.clientProfile.hrcRoles = JSON.parse(this.clientProfile.hrcRoles.toString())

      if (this.clientProfile.hrcRoles.length > 0) {
        this.highRiskClient = true
      }
    }
  }

  @Mutation
  setClientProduct (product: { meta: {}; _oid: string }) {
    this.clientProduct.extractMetaObject(product)
  }

  @Mutation
  setProductList (data: (string | number)[][]) {
    const productMetaList = new ProductFullMetaList(data)
    this.productList = productMetaList
  }

  @Mutation
  setReadOnly (readOnly: boolean) {
    this.readOnly = readOnly
  }

  @Mutation
  resetClientProduct () {
    this.clientProduct = new ClientProductMeta()
  }

  @Action
  async retrieveClientProfile (clientOid: string) {
    try {
      /* eslint-disable @typescript-eslint/camelcase */
      const res = await $api.clientDetails.profile({
        client_oid: clientOid
      })

      if (typeof res === 'string' && JSON.parse(res).error) {
        throw new Error(JSON.parse(res).error)
      }

      this.context.commit('setClientProfile', res)
    } catch (error) {
      alert(error.message || error)
    } finally {}
  }
}
